import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import DataTable from "../../components/ui/table";
import { useEffect, useState } from "react";
import getData from "../../api/project-request";
import { API_URL_COMPANY } from "../../constants";
import { CompanyRow } from "../../assets/utils/table-types";
import { deleteArrFunc } from "../../assets/utils/request-function";
import { useStructureStore } from "../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../assets/utils/enums/basket";
import { useStructureColumnsStore } from "../../assets/store/useStructureColumnsStore";

export default function CompanyMainPage() {
  const [loaderState, setLoaderState] = useState<boolean>(false);
  const [companies, setCompanies] = useState<CompanyRow[]>([]);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.COMPANIES].fields
  )
  const baseColumns =
    tableColumnType[TableTypeEnum.COMPANIES].columns;

  const tableStructure = useStructureColumnsStore(
    baseColumns,
    fields
  );

  const getCompanies = async () => {
    setLoaderState(true);
    try {
      const data = await getData(`${API_URL_COMPANY}/get-all-companies`);

      if (Array.isArray(data)) {
        setCompanies(data);
      } else {
        setCompanies([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setCompanies([]);
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 100);
    }
  };

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    getCompanies();
    setIsDeleted(false);
  }, [isDeleted]);

  return (
    <AppLayout className="" blockType="projects" loaderState={loaderState}>
      <Headline
        headline={HeadlineTypeEnum.COMPANIES}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Додати компанію"
        btn_link="/companies/add"
      />
      <DataTable
        key={JSON.stringify(tableStructure.map(c => `${c.key}-${c.label}-${c.visible}`))}
        table={{ ...tableColumnType[TableTypeEnum.COMPANIES], columns: tableStructure }}
        data={companies}
        itemsCount={10}
        deleteArrFunc={(queryArr) =>
          deleteArrFunc(
            queryArr,
            `${API_URL_COMPANY}/archive`,
            setIsDeleted,
            "companyIds"
          )
        }
      />
    </AppLayout>
  );
}
